const style = {

  message: {
    textAlign: 'center'
  }
}

export default style
